import React, { Component } from 'react'
import { addStepIcon, trashStepIcon, addSubstep } from "../../../../Templates/icons"
class TableActions extends Component {

    render() {
        return <div id="table-actions-container" className="flex-apart">
            <div id="table-actions-div" className="flex-apart" style={{width: "100%"}}>
               <div className="tableActions">{addStepIcon(this.props.addStep, this.props.isActive)}</div> 
               <div className="tableActions">{addSubstep(this.props.addSubstep, this.props.isActive)}</div>
               <div className="tableActions">{trashStepIcon(this.props.removeStep, this.props.isActive)}</div>
            </div>

        </div>
    }
}

export default TableActions